import { Breadcrumb, Switch, Timeline } from "antd";
import { t } from "i18next";
import { CloseIcon, ActiveDotIcon, InactiveDotIcon } from "../../../asset";
import style from './addressFormatConfigPage.module.css'
import CustomTable from "../../../component/table/CustomTable";
import PrimaryButton from "../../../component/button/PrimaryButton";
import { useState } from "react";
import { useAddFormatConfig } from "./AddressFormatConfigPage.hooks";
import SecondaryButton from "../../../component/button/SecondaryButton";
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import SuccessModal from "../../../component/modal/SuccessModal";
import ModalConfirmLeave from '../../../component/modal/ModalConfirmLeave';
import { ROUTES } from "../../../constant/routeConstant";


export default function AddressFormatConfigList() {

	const [userManagementOpen, setUserManagementOpen] = useState(false);

	const {
		list,
		convertTimestamp,
		convertToTime,
		editList,
		isEdit,
		doEdit,
		updateRow,
		doEditAddressFormatConfig,
		successModalOpen,
		setSuccessModalOpen,
		setShowConfirm,
		showConfirm,
		checkIsEdited,
		managementHistoryList
	} = useAddFormatConfig()

	const AddressFormatConfigurationColumn = [
		{
			title: (
				<span className="font-roboto text-lg text-[#222222]">
					{t("ADDRESS_FORMAT_CONFIG:FIELD_FIELD")}
				</span>
			),
			dataIndex: 'field',
			key: 'field',
			render: (field) => <span>{field}</span>,
		},
		{
			title: (
				<span className="font-roboto text-lg text-[#222222]">
					{t("ADDRESS_FORMAT_CONFIG:LABEL_FIELD")}
				</span>
			),
			dataIndex: 'label',
			key: 'label',
			render: (label) => <span>{label}</span>,
		},
		{
			title: (
				<span className="font-roboto text-lg text-[#222222]">
					{t("ADDRESS_FORMAT_CONFIG:SHOW_FIELD")}
				</span>
			),
			dataIndex: 'show',
			key: 'show',
			render: (show) => <span>{show}</span>,
		},
		{
			title: (
				<span className="font-roboto text-lg text-[#222222]">
					{t("ADDRESS_FORMAT_CONFIG:MANDATORY_FIELD")}
				</span>
			),
			dataIndex: 'mandatory',
			key: 'mandatory',
			render: (mandatory) => <span>{mandatory}</span>,
		},
		{
			title: (
				<span className="font-roboto text-lg text-[#222222]">
					{t("ADDRESS_FORMAT_CONFIG:CONSIDER_FOR_GEOCODING_FIELD")}
				</span>
			),
			dataIndex: 'geocoding',
			key: 'geocoding',
			render: (geocoding) => <span>{geocoding}</span>,
		},
	]

	const dataSource = !isEdit ?
		list?.ListAddressFormatConfiguration.map((item) => ({
			field: (
				<span className="font-roboto text-lg text-[#222222]">
					{item.field}
				</span>
			),
			label: (
				<span className="font-roboto text-lg text-[#222222]">
					{item.label}
				</span>
			),
			show: (
				<span className="font-roboto text-lg text-[#222222]">
					{item.show}
				</span>
			),
			mandatory: (
				<span className="font-roboto text-lg text-[#222222]">
					{item.mandatory}
				</span>
			),
			geocoding: (
				<span className="font-roboto text-lg text-[#222222]">
					{item.consider_for_geocoding}
				</span>
			),
		}))

		:

		editList?.map((item, index) => {
			if (item.label === 'Postal Code' || item.label === 'Country') {
				return ({
					field: (
						<span className="font-roboto text-lg text-[#222222]">
							{item.field}
						</span>
					),
					label: (
						<span className="font-roboto text-lg text-[#222222]">
							{item.label}
						</span>
					),
					show: (
						<div className="flex gap-[10px]">
							<label className={style.switch}>
								<input type="checkbox" checked />
								<span className={`${style.round} ${style.sliderPermanent}`}></span>
							</label>
							<p className={item.show == "Y" ? style.inputLabelActive : style.inputLabel} style={{ color: '#ACACAC' }}>Yes</p>
						</div>
					),
					mandatory: (
						<div className="flex gap-[10px]">
							<label className={style.switch}>
								<input type="checkbox" checked />
								<span className={`${style.round} ${style.sliderPermanent}`}></span>
							</label>
							<p className={item.mandatory == "Y" ? style.inputLabelActive : style.inputLabel} style={{ color: '#ACACAC' }}>Yes</p>
						</div>
					),
					geocoding: (
						<div className="flex gap-[10px]">
							<label className={style.switch}>
								<input type="checkbox" defaultChecked={item.consider_for_geocoding == "Y" ? true : false} onChange={() => updateRow(item, index, 'geocoding', `${item.consider_for_geocoding == "Y" ? "N" : "Y"}`)} />
								<span className={`${style.round} ${style.slider}`}></span>
							</label>
							<p className={item.consider_for_geocoding == "Y" ? style.inputLabelActive : style.inputLabel}>Yes</p>
						</div>
					),
				})
			} else {
				return ({
					field: (
						<span className="font-roboto text-lg text-[#222222]">
							{item.field}
						</span>
					),
					label: (
						<span className="font-roboto text-lg text-[#222222]">
							{item.label}
						</span>
					),
					show: (
						<div className="flex gap-[10px]">
							<label className={style.switch}>
								<input type="checkbox" defaultChecked={item.show == "Y" ? true : false} onChange={() => updateRow(item, index, 'show', `${item.show == "Y" ? "N" : "Y"}`)} />
								<span className={`${style.round} ${style.slider}`}></span>
							</label>
							<p className={item.show == "Y" ? style.inputLabelActive : style.inputLabel}>Yes</p>
						</div>
					),
					mandatory: (
						<div className="flex gap-[10px]">
							<label className={style.switch}>
								<input type="checkbox" defaultChecked={item.mandatory == "Y" ? true : false} onChange={() => updateRow(item, index, 'mandatory', `${item.mandatory == "Y" ? "N" : "Y"}`)} />
								<span className={`${style.round} ${style.slider}`}></span>
							</label>
							<p className={item.mandatory == "Y" ? style.inputLabelActive : style.inputLabel}>Yes</p>
						</div>
					),
					geocoding: (
						<div className="flex gap-[10px]">
							<label className={style.switch}>
								<input type="checkbox" defaultChecked={item.consider_for_geocoding == "Y" ? true : false} onChange={() => updateRow(item, index, 'geocoding', `${item.consider_for_geocoding == "Y" ? "N" : "Y"}`)} />
								<span className={`${style.round} ${style.slider}`}></span>
							</label>
							<p className={item.consider_for_geocoding == "Y" ? style.inputLabelActive : style.inputLabel}>Yes</p>
						</div>
					),
				})
			}
		})

	return (
		<div className='p-[24px] flex flex-col gap-[24px]'>

			<ModalConfirmLeave
				visible={showConfirm}
				action={() => window.location.reload(false)}
				routes={ROUTES.ADDRESS_FORMAT_CONFIG.LIST}
				stay={() => setShowConfirm(false)}
			/>

			<SuccessModal
				isOpen={successModalOpen}
				closable={false}
				onOk={() => setSuccessModalOpen(false)}
				width={280}
				className={style.successModal}
				okText="Ok"
				title="Success"
				description={`Your data has been updated`}
			/>

			{
				!isEdit ?
					<Breadcumbs
						jmlLevel={3}
						menuLevel1={`Setup`}
						menuLevel2={`Profile Configuration`}
						menuLevel3={`Address Format Configuration`}
					/>

					:

					<Breadcumbs
						jmlLevel={4}
						menuLevel1={`Setup`}
						menuLevel2={`Profile Configuration`}
						menuLevel3={`Address Format Configuration`}
						menuLevel4={`Edit Address Format Configuration`}
					/>
			}

			<div className="flex justify-between">
				<h1 className='font-sans-bold text-2xl' id='title'>{t("ADDRESS_FORMAT_CONFIG:TITLE")}</h1>
				<div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer' onClick={() => setUserManagementOpen(true)}>
					<p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{list?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(list?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} <strong>{list?.updated_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(list?.updated_at, true)}</strong></p>
				</div>
			</div>

			<div className={style.tableContainer}>

				<CustomTable showPagination={false} columns={AddressFormatConfigurationColumn} data={dataSource} />

			</div>

			<div className="flex justify-end">
				{
					!isEdit ?
						<PrimaryButton text={t("ADDRESS_FORMAT_CONFIG:EDIT")} action={() => doEdit(true)} />
						:
						<div className="flex justify-start flex-row-reverse gap-[16px]">
							<PrimaryButton text={t("ADDRESS_FORMAT_CONFIG:SAVE")} action={() => doEditAddressFormatConfig(list?.updated_at)} />
							<SecondaryButton text={t("ADDRESS_FORMAT_CONFIG:CANCEL")} action={() => checkIsEdited()} />
						</div>
				}
			</div>


			<aside className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
				<button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
					<img src={CloseIcon} alt="" />
				</button>

				<h3 className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
				<p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{list?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(list?.created_at)}</strong></p>


				<div className={style.timelineContainer}>
					<Timeline>
						{
							managementHistoryList.map((item, index) => {
								if (index === 0) {
									return (
										<Timeline.Item dot={<img src={ActiveDotIcon} />}>
											<div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
												<h4 className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
												<h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
												<p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
											</div>
										</Timeline.Item>
									)
								} else {
									return (
										<Timeline.Item dot={<img src={InactiveDotIcon} />}>
											<div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
												<h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
												<h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
												<p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
											</div>
										</Timeline.Item>
									)
								}
							})
						}
					</Timeline>
				</div>
			</aside>
		</div>
	);
}

